import React from 'react';

const ScrollArrow2 = (props) => (
  <svg width="15" height="36" viewBox="0 0 15 36" {...props}>
    <path d="M7.48657 34.3333L7.48657 1" strokeWidth="1.33333" strokeMiterlimit="10" strokeLinecap="round" />
    <path
      d="M13.98 28.0801L7.48665 34.5667L0.999981 28.0801"
      strokeWidth="1.33333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ScrollArrow2;
